export default __webpack_public_path__ + "static/media/ActiveBucket.cf88075f.svg";